import React, { useState } from 'react';
import { Facebook, Instagram, Linkedin, Mail, Youtube } from 'lucide-react';
import { motion } from 'framer-motion';
import { Zap, ShoppingCart, Download, FileText, Shield } from 'lucide-react';
import { Modal } from './Modal';
type ModalType = 'privacy' | 'terms' | 'contact' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  const renderModalContent = () => {
    switch (activeModal) {
      case 'privacy':
        return <div className="space-y-6" data-id="element-81">
            <p className="text-sm text-gray-500 italic" data-id="element-82">
              Última actualización: {new Date().toLocaleDateString()}
            </p>
            <section data-id="element-83">
              <h3 className="text-lg font-bold text-[#1a3a52] mb-2" data-id="element-84">
                1. Recopilación de Información
              </h3>
              <p data-id="element-85">
                Recopilamos información que usted nos proporciona directamente
                cuando utiliza nuestros servicios, se registra en nuestra
                plataforma o se comunica con nosotros. Esta información puede
                incluir su nombre, dirección de correo electrónico y cualquier
                otro dato que decida compartir.
              </p>
            </section>
            <section data-id="element-86">
              <h3 className="text-lg font-bold text-[#1a3a52] mb-2" data-id="element-87">
                2. Uso de la Información
              </h3>
              <p data-id="element-88">
                Utilizamos la información recopilada para proporcionar, mantener
                y mejorar nuestros servicios, procesar transacciones, enviar
                notificaciones técnicas y responder a sus comentarios y
                preguntas.
              </p>
            </section>
            <section data-id="element-89">
              <h3 className="text-lg font-bold text-[#1a3a52] mb-2" data-id="element-90">
                3. Protección de Datos
              </h3>
              <p data-id="element-91">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger sus datos personales contra el acceso
                no autorizado, la alteración, la divulgación o la destrucción.
              </p>
            </section>
            <section data-id="element-92">
              <h3 className="text-lg font-bold text-[#1a3a52] mb-2" data-id="element-93">
                4. Cookies y Tecnologías Similares
              </h3>
              <p data-id="element-94">
                Utilizamos cookies y tecnologías similares para mejorar su
                experiencia en nuestro sitio web, analizar tendencias y
                administrar la plataforma. Puede configurar su navegador para
                rechazar todas las cookies o para que le avise cuando se envíe
                una cookie.
              </p>
            </section>
            <section data-id="element-95">
              <h3 className="text-lg font-bold text-[#1a3a52] mb-2" data-id="element-96">
                5. Sus Derechos
              </h3>
              <p data-id="element-97">
                Usted tiene derecho a acceder, corregir o eliminar su
                información personal. Si desea ejercer estos derechos, por favor
                contáctenos a través de los canales proporcionados.
              </p>
            </section>
          </div>;
      case 'terms':
        return <div className="space-y-6" data-id="element-98">
            <p className="text-sm text-gray-500 italic" data-id="element-99">
              Última actualización: {new Date().toLocaleDateString()}
            </p>
            <section data-id="element-100">
              <h3 className="text-lg font-bold text-[#1a3a52] mb-2" data-id="element-101">
                1. Aceptación de los Términos
              </h3>
              <p data-id="element-102">
                Al acceder y utilizar este sitio web, usted acepta estar sujeto
                a estos Términos y Condiciones. Si no está de acuerdo con alguna
                parte de estos términos, no podrá acceder al servicio.
              </p>
            </section>
            <section data-id="element-103">
              <h3 className="text-lg font-bold text-[#1a3a52] mb-2" data-id="element-104">
                2. Uso del Servicio
              </h3>
              <p data-id="element-105">
                Se le concede una licencia limitada, no exclusiva e
                intransferible para acceder y utilizar nuestros servicios para
                fines personales y no comerciales, de acuerdo con estos
                términos.
              </p>
            </section>
            <section data-id="element-106">
              <h3 className="text-lg font-bold text-[#1a3a52] mb-2" data-id="element-107">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-108">
                Todo el contenido, características y funcionalidad de este sitio
                (incluyendo, pero no limitado a, textos, gráficos, logotipos,
                imágenes y software) son propiedad exclusiva de Comunicación
                Magnética y están protegidos por leyes de derechos de autor y
                marcas registradas.
              </p>
            </section>
            <section data-id="element-109">
              <h3 className="text-lg font-bold text-[#1a3a52] mb-2" data-id="element-110">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-111">
                En ningún caso Comunicación Magnética, ni sus directores,
                empleados o afiliados, serán responsables por daños indirectos,
                incidentales, especiales, consecuentes o punitivos resultantes
                de su uso o imposibilidad de uso del servicio.
              </p>
            </section>
            <section data-id="element-112">
              <h3 className="text-lg font-bold text-[#1a3a52] mb-2" data-id="element-113">
                5. Modificaciones
              </h3>
              <p data-id="element-114">
                Nos reservamos el derecho de modificar o reemplazar estos
                términos en cualquier momento. Es su responsabilidad revisar
                periódicamente estos términos para verificar cambios.
              </p>
            </section>
          </div>;
      case 'contact':
        return <div className="flex flex-col items-center justify-center py-8 text-center space-y-6" data-id="element-115">
            <div className="w-16 h-16 bg-[#1a3a52]/5 rounded-full flex items-center justify-center text-[#C9A961] mb-2" data-id="element-116">
              <Mail size={32} data-id="element-117" />
            </div>
            <div data-id="element-118">
              <p className="text-lg text-[#1a3a52] mb-2 font-medium" data-id="element-119">
                Para consultas, escríbenos a:
              </p>
              <a href="mailto:contactomikioscodigital@gmail.com" className="text-xl md:text-2xl font-bold text-[#C9A961] hover:text-[#1a3a52] transition-colors break-all" data-id="element-120">
                contactomikioscodigital@gmail.com
              </a>
            </div>
            <p className="text-sm text-gray-500 max-w-md" data-id="element-121">
              Nuestro equipo de soporte te responderá a la brevedad posible. El
              horario de atención es de Lunes a Viernes de 9:00 a 18:00 hrs.
            </p>
          </div>;
      default:
        return null;
    }
  };
  const getModalTitle = () => {
    switch (activeModal) {
      case 'privacy':
        return 'Política de Privacidad';
      case 'terms':
        return 'Términos y Condiciones';
      case 'contact':
        return 'Contacto';
      default:
        return '';
    }
  };
  return <>
      {/* Premium Offer Box - Moved from PremiumPackOffer */}
      <div className="bg-black py-12" data-id="element-122">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} data-id="element-124">
            <div className="relative overflow-hidden rounded-3xl p-6 md:p-10 bg-gradient-to-br from-[#FF512F] via-[#F09819] to-[#FF512F] shadow-[0_0_50px_rgba(255,81,47,0.6)] border-4 border-[#FFD700]/50" data-id="element-125">
              {/* Blinking Lights / Particles */}
              {[...Array(15)].map((_, i) => <motion.div key={i} className="absolute rounded-full bg-white blur-sm" style={{
              width: Math.random() * 10 + 5,
              height: Math.random() * 10 + 5,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`
            }} animate={{
              opacity: [0, 1, 0],
              scale: [0.5, 1.5, 0.5]
            }} transition={{
              duration: Math.random() * 2 + 1,
              repeat: Infinity,
              delay: Math.random() * 2
            }} data-id="element-126" />)}

              {/* 3D Shopping Cart Icon - Floating Background Element */}
              <motion.div className="absolute top-0 right-0 opacity-20 text-yellow-200 pointer-events-none transform translate-x-1/4 -translate-y-1/4" animate={{
              y: [0, -20, 0],
              rotate: [0, 5, 0]
            }} transition={{
              duration: 6,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-127">
                <ShoppingCart size={250} strokeWidth={1.5} data-id="element-128" />
              </motion.div>

              <div className="relative z-10 text-center" data-id="element-129">
                {/* Header */}
                <motion.div className="inline-block mb-4" animate={{
                scale: [1, 1.05, 1]
              }} transition={{
                duration: 2,
                repeat: Infinity
              }} data-id="element-130">
                  <span className="bg-white text-[#FF512F] px-6 py-2 rounded-full font-black text-lg md:text-xl uppercase tracking-widest shadow-lg border-4 border-yellow-400 transform -rotate-2 inline-block" data-id="element-131">
                    Promoción por tiempo limitado
                  </span>
                </motion.div>

                <h3 className="text-3xl md:text-4xl font-black text-white mb-3 drop-shadow-[0_4px_4px_rgba(0,0,0,0.5)] leading-tight" data-id="element-132">
                  Compra 1 Ebook Digital
                  <br data-id="element-133" />
                  <span className="text-yellow-200 text-4xl md:text-5xl block mt-2" data-id="element-134">
                    Llévate 7 Ebooks
                  </span>
                  <span className="text-2xl md:text-3xl block mt-2" data-id="element-135">
                    (Edición Premium)
                  </span>
                </h3>

                <div className="bg-black/30 backdrop-blur-sm rounded-2xl p-6 mb-6 border-2 border-yellow-300/50" data-id="element-136">
                  <p className="text-white font-bold text-lg md:text-xl mb-2" data-id="element-137">
                    Valor Total:{' '}
                    <span className="line-through text-gray-300" data-id="element-138">$250.00</span>
                  </p>
                  <p className="text-yellow-200 font-black text-3xl md:text-4xl mb-2" data-id="element-139">
                    Precio Especial: $9.95
                  </p>
                  <p className="text-white text-sm md:text-base" data-id="element-140">
                    Por la compra del ebook digital COMUNICACIÓN MAGNÉTICA
                  </p>
                </div>

                <p className="text-xl md:text-2xl text-white font-bold mb-6 drop-shadow-md flex items-center justify-center gap-3" data-id="element-141">
                  <Zap className="text-yellow-300 fill-yellow-300 animate-pulse" data-id="element-142" />
                  Acceso digital inmediato. Sin esperas.
                </p>

                {/* 3D Luminous Button */}
                <div className="relative inline-block group max-w-full" data-id="element-143">
                  {/* Animated Rainbow Border/Glow */}
                  <motion.div className="absolute -inset-2 rounded-full opacity-75 blur-xl" style={{
                  background: 'linear-gradient(90deg, #FF0000, #FFFF00, #00FF00, #00FFFF, #0000FF, #FF00FF, #FF0000)',
                  backgroundSize: '400% 100%'
                }} animate={{
                  backgroundPosition: ['0% 50%', '100% 50%']
                }} transition={{
                  duration: 3,
                  repeat: Infinity,
                  ease: 'linear'
                }} data-id="element-144" />

                  <motion.a href="https://mikioscodigital.com/cart/51802866975001:1" whileHover={{
                  scale: 1.05
                }} whileTap={{
                  scale: 0.95
                }} animate={{
                  scale: [1, 1.02, 1]
                }} transition={{
                  scale: {
                    duration: 1.5,
                    repeat: Infinity
                  }
                }} className="relative flex flex-col md:flex-row items-center justify-center gap-3 md:gap-4 bg-gradient-to-b from-yellow-400 to-orange-600 text-white border-b-8 border-orange-800 px-6 py-4 rounded-full font-black text-lg md:text-xl shadow-[0_10px_20px_rgba(0,0,0,0.4)] hover:shadow-[0_20px_40px_rgba(0,0,0,0.5)] transition-all transform active:translate-y-2 active:border-b-0 w-full md:w-auto" data-id="element-145">
                    <div className="bg-white/20 p-2 rounded-full" data-id="element-146">
                      <ShoppingCart className="w-6 h-6 md:w-8 md:h-8 drop-shadow-md text-white" data-id="element-147" />
                    </div>
                    <span className="drop-shadow-md text-center" data-id="element-148">
                      Sí, quiero Mi Edición Premium por $9.95
                    </span>
                  </motion.a>
                </div>

                {/* Trust Indicators */}
                <div className="mt-8 flex flex-wrap justify-center gap-4 md:gap-6 text-white font-bold text-xs md:text-sm" data-id="element-149">
                  <div className="flex items-center gap-2 bg-black/20 px-4 py-2 rounded-xl backdrop-blur-sm border border-white/10 shadow-lg" data-id="element-150">
                    <Download size={20} className="text-yellow-300" data-id="element-151" />
                    <span data-id="element-152">Descarga inmediata</span>
                  </div>
                  <div className="flex items-center gap-2 bg-black/20 px-4 py-2 rounded-xl backdrop-blur-sm border border-white/10 shadow-lg" data-id="element-153">
                    <FileText size={20} className="text-yellow-300" data-id="element-154" />
                    <span data-id="element-155">7 ebooks digitales</span>
                  </div>
                  <div className="flex items-center gap-2 bg-black/20 px-4 py-2 rounded-xl backdrop-blur-sm border border-white/10 shadow-lg" data-id="element-156">
                    <Shield size={20} className="text-yellow-300" data-id="element-157" />
                    <span data-id="element-158">Garantía de 30 días</span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      <footer className="bg-[#1a3a52] text-white py-12 border-t border-[#C9A961]/20" data-id="element-159">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-160">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-161">
            {/* Copyright */}
            <div className="text-center text-sm text-gray-400" data-id="element-162">
              <p data-id="element-163">
                copyright © 2024 comunicación magnética todos los derechos
                reservados.
              </p>
            </div>

            {/* Links */}
            <div className="flex flex-wrap justify-center gap-6 text-sm font-medium text-gray-300" data-id="element-164">
              <button onClick={() => setActiveModal('privacy')} className="hover:text-[#C9A961] transition-colors focus:outline-none focus:text-[#C9A961]" data-id="element-165">
                Política de Privacidad
              </button>
              <button onClick={() => setActiveModal('terms')} className="hover:text-[#C9A961] transition-colors focus:outline-none focus:text-[#C9A961]" data-id="element-166">
                Términos y Condiciones
              </button>
              <button onClick={() => setActiveModal('contact')} className="hover:text-[#C9A961] transition-colors focus:outline-none focus:text-[#C9A961]" data-id="element-167">
                Contacto
              </button>
            </div>

            {/* Social Icons */}
            <div className="flex gap-4" data-id="element-168">
              <a href="https://www.facebook.com/contactokd/" className="w-10 h-10 bg-white/10 text-white rounded-full flex items-center justify-center hover:bg-[#C9A961] hover:text-[#1a3a52] transition-all duration-300" aria-label="Facebook" target="_blank" rel="noopener noreferrer" data-id="element-169">
                <Facebook size={18} data-id="element-170" />
              </a>
              <a href="https://www.youtube.com/@mikioscodigital" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 text-white rounded-full flex items-center justify-center hover:bg-[#C9A961] hover:text-[#1a3a52] transition-all duration-300" aria-label="YouTube" data-id="element-171">
                <Youtube size={18} data-id="element-172" />
              </a>
              <a href="https://www.instagram.com/kiosscodigital/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 text-white rounded-full flex items-center justify-center hover:bg-[#C9A961] hover:text-[#1a3a52] transition-all duration-300" aria-label="Instagram" data-id="element-173">
                <Instagram size={18} data-id="element-174" />
              </a>
            </div>
          </div>
        </div>
      </footer>

      <Modal isOpen={activeModal !== null} onClose={closeModal} title={getModalTitle()} data-id="element-175">
        {renderModalContent()}
      </Modal>
    </>;
}